import { MAX_TOAST_COUNT } from '../../../../../shared/constants';
import * as NotificationsSelectors from '../notifications';

function get(state) {
    return state.toasts;
}

export function isEmpty(state) {
    return get(state).length === 0;
}

export function isFull(state) {
    return get(state).length >= MAX_TOAST_COUNT;
}

export function getActiveNotifications(state) {
    const notificationIds = get(state);
    return notificationIds.map((id) => NotificationsSelectors.getNotificationById(state, id));
}
